import { medicalRecord } from '~/constants'

export enum EBiologicalSex {
  MALE = 'Masculino',
  FEMALE = 'Feminino',
  UNKNOWN = 'Desconhecido',
  UNDEFINED = 'Indeterminado'
}

export enum EPatientsColor {
  WHITE = 1, // branco
  BLACK = 2, // preto
  MIXED = 3, // pardo
  ASIAN = 4, // amarelo
  INDIGENOUS = 5, // vermelho/indígena
  UNKNOWN = 6 // desconhecido
}

export type UnionTypeBiologicalSex = `${EBiologicalSex}`

interface IPatient {
  id: number
  name: string
  bloodType?: string
  medicalRecord: string
  birthDate: string
  biologicalSex: UnionTypeBiologicalSex
  color: EPatientsColor
  hasPregnancies?: boolean
}

interface IPatientsPageable {
  data: IPatient[]
  metadata: {
    count: number
    offset: number
    limit: number
    total: number
  }
}

interface IGetPatientsParams {
  queryParams: {
    name: string
    offset: string
    limit: string
  }
}

interface IGetPatientParams {
  pathParams: {
    [medicalRecord]: number
  }
}

export type { IGetPatientParams, IGetPatientsParams, IPatient, IPatientsPageable }
